import React, { useLayoutEffect, useRef, useEffect, useState, useMemo } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import ButtonAdd from '../../components/ButtonAdd';
import { setAuthHeaders } from '../../utils/common';
import axiosInstance from '../../axiosHttp';
import API_URL from '../../constant/api.config';
import { toExcel } from 'to-excel';

function MultiRadarCharts({ dashboardData }) {
  const chartRef3 = useRef({});
  const [data, setData] = useState([]);

  const tradeModeLabels = {
    BUYER: "Buyer",
    SUPPLIER: "Supplier",
    LOG_PTR: "Logistic Partner"
  };

  const tradeModeOrder = ["LOG_PTR", "SUPPLIER", "BUYER"];

  // Shared color map
  const colorMap = {
    Paid: "#FF6B6B",
    Review: "#0096a2",
    Total: "#0b4471",
  };

  useEffect(() => {
    if (dashboardData) {
      setData(dashboardData);
    }
  }, [dashboardData]);

  //  const sortedData = [...data].sort((a, b) => {
  //   return tradeModeOrder.indexOf(a.trade_mode_type) - tradeModeOrder.indexOf(b.trade_mode_type);
  // });
  const sortedData = useMemo(() => {
    return [...data].sort(
      (a, b) => tradeModeOrder.indexOf(a.trade_mode_type) - tradeModeOrder.indexOf(b.trade_mode_type)
    );
  }, [data]);

  const calculateChartData = (rawDataItem) => {
    const { total_count, review_count, paid_count } = rawDataItem;
    const safeTotal = total_count > 0 ? total_count : 1;

    return [
      {
        category: "Paid",
        value: parseFloat(((paid_count / safeTotal) * 100).toFixed(4)),
        full: 100,
      },
      {
        category: "Review",
        value: parseFloat(((review_count / safeTotal) * 100).toFixed(4)),
        full: 100,
      },
      {
        category: "Total",
        value: 100,
        full: 100,
      },
    ];
  };


  // const createRadarChart = (ref, rawData) => {

  //   const root = am5.Root.new(ref);
  //   root.setThemes([am5themes_Animated.new(root)]);
  //   root._logo.dispose(); //remove logo

  //   const chart = root.container.children.push(
  //     am5radar.RadarChart.new(root, {
  //       panX: false,
  //       wheelX: "none",
  //       wheelY: "none",
  //       innerRadius: am5.percent(30),
  //       startAngle: -90,
  //       endAngle: 180,
  //       paddingLeft: 0,
  //       paddingRight: 0,
  //     })
  //   );

  //   const cursor = chart.set("cursor", am5radar.RadarCursor.new(root, { behavior: "zoomX" }));
  //   cursor.lineY.set("visible", false);

  //   const xRenderer = am5radar.AxisRendererCircular.new(root, {});
  //   xRenderer.labels.template.setAll({ radius: 10, fontSize: 14, fontWeight: "600", fill: am5.color("#000") });
  //   xRenderer.grid.template.setAll({ forceHidden: true });

  //   const xAxis = chart.xAxes.push(
  //     am5xy.ValueAxis.new(root, {
  //       renderer: xRenderer,
  //       min: 0,
  //       max: 100,
  //       strictMinMax: true,
  //       numberFormat: "#'%'",
  //       tooltip: am5.Tooltip.new(root, {}),
  //     })
  //   );

  //   const yRenderer = am5radar.AxisRendererRadial.new(root, { minGridDistance: 20 });
  //   yRenderer.labels.template.setAll({ centerX: am5.p100, fontWeight: "500", fontSize: 16, templateField: "columnSettings" });
  //   yRenderer.grid.template.setAll({ forceHidden: true });

  //   const yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
  //     categoryField: "category",
  //     renderer: yRenderer,
  //   }));

  //   const coloredData = rawData.map(item => ({
  //     ...item,
  //     columnSettings: {
  //       fill: am5.color(colorMap[item.category] || "#ccc"),
  //     },
  //   }));

  //   yAxis.data.setAll(coloredData);

  //   // Background full bars
  //   const series1 = chart.series.push(am5radar.RadarColumnSeries.new(root, {
  //     xAxis,
  //     yAxis,
  //     clustered: false,
  //     valueXField: "full",
  //     categoryYField: "category",
  //     fill: root.interfaceColors.get("alternativeBackground"),
  //   }));
  //   series1.columns.template.setAll({ width: am5.percent(100), fillOpacity: 0.08, strokeOpacity: 0, cornerRadius: 20 });
  //   series1.data.setAll(coloredData);

  //   // Foreground data bars
  //   const series2 = chart.series.push(am5radar.RadarColumnSeries.new(root, {
  //     xAxis,
  //     yAxis,
  //     clustered: false,
  //     valueXField: "value",
  //     categoryYField: "category",
  //   }));
  //   series2.columns.template.setAll({
  //     width: am5.percent(100),
  //     strokeOpacity: 0,
  //     tooltipText: "{category}: {valueX}%",
  //     cornerRadius: 20,
  //     templateField: "columnSettings",
  //   });
  //   series2.data.setAll(coloredData);

  //   series1.appear(600);
  //   series2.appear(600);
  //   chart.appear(600, 100);

  //   return () => root.dispose();
  // };

  const createRadarChart = (ref, rawData) => {
    if (!ref) return;

    // Dispose any previous chart attached to this ref
    if (ref._amchartRoot) {
      ref._amchartRoot.dispose();
    }

    const root = am5.Root.new(ref);
    ref._amchartRoot = root; // Store root for disposal later

    root.setThemes([am5themes_Animated.new(root)]);
    root._logo.dispose();

    const chart = root.container.children.push(
      am5radar.RadarChart.new(root, {
        panX: false,
        wheelX: "none",
        wheelY: "none",
        innerRadius: am5.percent(30),
        startAngle: -90,
        endAngle: 180,
        paddingLeft: 0,
        paddingRight: 0,
      })
    );

    const cursor = chart.set("cursor", am5radar.RadarCursor.new(root, { behavior: "zoomX" }));
    cursor.lineY.set("visible", false);

    const xRenderer = am5radar.AxisRendererCircular.new(root, {});
    xRenderer.labels.template.setAll({ radius: 10, fontSize: 14, fontWeight: "600", fill: am5.color("#000") });
    xRenderer.grid.template.setAll({ forceHidden: true });

    const xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: xRenderer,
        min: 0,
        max: 100,
        strictMinMax: true,
        numberFormat: "#'%'",
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    const yRenderer = am5radar.AxisRendererRadial.new(root, { minGridDistance: 20 });
    yRenderer.labels.template.setAll({ centerX: am5.p100, fontWeight: "500", fontSize: 16, templateField: "columnSettings" });
    yRenderer.grid.template.setAll({ forceHidden: true });

    const yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: yRenderer,
    }));

    const coloredData = rawData.map(item => ({
      ...item,
      columnSettings: {
        fill: am5.color(colorMap[item.category] || "#ccc"),
      },
    }));

    yAxis.data.setAll(coloredData);

    // Background
    const series1 = chart.series.push(am5radar.RadarColumnSeries.new(root, {
      xAxis,
      yAxis,
      clustered: false,
      valueXField: "full",
      categoryYField: "category",
      fill: root.interfaceColors.get("alternativeBackground"),
    }));
    series1.columns.template.setAll({ width: am5.percent(100), fillOpacity: 0.08, strokeOpacity: 0, cornerRadius: 20 });
    series1.data.setAll(coloredData);

    // Foreground
    const series2 = chart.series.push(am5radar.RadarColumnSeries.new(root, {
      xAxis,
      yAxis,
      clustered: false,
      valueXField: "value",
      categoryYField: "category",
    }));
    series2.columns.template.setAll({
      width: am5.percent(100),
      strokeOpacity: 0,
      tooltipText: "{category}: {valueX}%",
      cornerRadius: 20,
      templateField: "columnSettings",
    });
    series2.data.setAll(coloredData);

    series1.appear(600);
    series2.appear(600);
    chart.appear(600, 100);

    return () => root.dispose();
  };




  useLayoutEffect(() => {
    if (sortedData && sortedData.length) {
      const disposers = [];

      sortedData.forEach((item) => {
        const chartData = calculateChartData(item);
        const chartContainer = chartRef3.current[item.trade_mode_type];

        if (chartContainer) {
          const dispose = createRadarChart(chartContainer, chartData);
          disposers.push(dispose);
        }
      });

      return () => {
        disposers.forEach(dispose => dispose && dispose());
      };
    }
  }, [sortedData]);



  const handleExport = (type) => {
    const headers = setAuthHeaders();
    let typeChange = '';
    if (type === 'LOG_PTR') {
      typeChange = 'LOGISTIC_PARTNER';
    } else {
      typeChange = type;
    }
    axiosInstance
      .get(API_URL + "/adminExcelData/" + type, { headers })
      .then((response) => {

        var data = response.data.data;
        var headers = response.data.headers;

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}_${hours}_${minutes}_${seconds}`;

        toExcel.exportXLS(headers, data, 'OREX_' + typeChange + '_' + formattedDate);
      }).catch((err) => {
        console.log("Error ==== ", err);
      });
  }



  return (
    <>

      {sortedData.map((item, index) => (
        <div key={index} className="col-xxl-3 col-xl-6 col-lg-6 col-md-12 col-sm-12 mobile-seprator">
          <div className="chart-section">
            <div className="head underline">
              <h3 className="m-0">{tradeModeLabels[item.trade_mode_type] || item.trade_mode_type}</h3>
              {/* <ButtonAdd className='export-btn' type="button" onClick={() => handleExport(item.trade_mode_type)}>
                <i className="sprite download"></i>
              </ButtonAdd> */}
            </div>
            <div className="chart-wrape">
              <div className="stats">
                <p className="total">Total <span>{item.total_count}</span></p>
                <p className="review">Review <span>{item.review_count}</span></p>
                <p className="paid">Paid <span>{item.paid_count}</span></p>
              </div>
              <div
                className="chart"
                ref={el => chartRef3.current[item.trade_mode_type] = el}
                style={{ width: "100%", height: "270px" }}
              />
            </div>
          </div>
        </div>
      ))}

      {/* <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-12 col-sm-12 mobile-seprator" >
            <div className="chart-section">
              <div className="head underline">
                <h3 className="m-0">Suppliers</h3>
                <ButtonAdd className='export-btn' type="button" onClick={() => handleExport('SUPPLIER')}>
                  <i className="sprite download"></i>
                </ButtonAdd>
              </div>
              <div className="chart-wrape">
                <div className="stats">
                  <p className="total">Total <span>{data[2].total_count}</span></p>
                  <p className="review">Review <span>{data[2].review_count}</span></p>
                  <p className="paid">Paid <span>{data[2].paid_count}</span></p>
                </div>
                <div className="chart" ref={chartRef3} style={{ width: "100%", height: "270px" }} />
              </div>
            </div>
          </div> */}
      {/* <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-12 col-sm-12 mobile-seprator" >
            <div className="chart-section">
              <div className="head underline">
                <h3 className="m-0">Logistic Partners</h3>
                <ButtonAdd className='export-btn' type="button" onClick={() => handleExport('LOG_PTR')}>
                  <i className="sprite download"></i>
                </ButtonAdd>
              </div>
              <div className="chart-wrape">
                <div className="stats">
                  <p className="total">Total <span>{data[1].total_count}</span></p>
                  <p className="review">Review <span>{data[1].review_count}</span></p>
                  <p className="paid">Paid <span>{data[1].paid_count}</span></p>
                </div>
                <div className="chart" ref={chartRef2} style={{ width: "100%", height: "270px" }} />
              </div>
            </div>
          </div> */}

    </>
  );
}

export default MultiRadarCharts;
